import { render } from "./ConfirmDialogBox.vue?vue&type=template&id=617e51ff&scoped=true"
import script from "./ConfirmDialogBox.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogBox.vue?vue&type=script&lang=js"

import "./ConfirmDialogBox.vue?vue&type=style&index=0&id=617e51ff&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617e51ff"]])

export default __exports__